import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { ListItemButton, ListItemIcon, ListItemText, IconButton, Tooltip } from '@mui/material';
import { NotificationContext } from '../../../../../NotificationContext';
import { useUpdateUser } from '../../../../../data/generic-queries/users';
import renderIcon from '../../shared/icons';
import NavChip from './NavChip';

const NavItemRenderer = ({ item, textSx, user, bookmarks, noIcon = false }) => {
    const { showSnackbar } = useContext(NotificationContext);
    const isBookmark = bookmarks?.includes(item.id);
    const editNavigationBookmarks = useUpdateUser({ key: 'navigation_bookmarks' });

    const onBookmarkClick = async () => {
        try {
            const updated = isBookmark
                ? bookmarks.filter((id) => id !== item.id) // wrap
                : [...(bookmarks || []), item.id];

            await editNavigationBookmarks.mutateAsync({
                id: user.id,
                data: { navigation_bookmarks: updated },
            });
            showSnackbar({ severity: 'success', message: `${item.title} ${isBookmark ? 'removed from' : 'added to'} bookmarks` });
        } catch (error) {
            showSnackbar({ severity: 'error', message: 'Failed to update bookmarks' });
        }
    };

    return (
        <ListItemButton
            component={NavLink}
            to={item.path}
            sx={(theme) => ({
                '&:hover': {
                    textDecoration: 'none !important',
                    backgroundColor: theme.palette.nav.background.highlight,
                },
                '&.active .MuiTypography-root': {
                    color: theme.palette.primary.main,
                },
                '&.active .MuiListItemIcon-root svg path': {
                    fill: theme.palette.primary.main,
                },
            })}
        >
            {!noIcon && (
                <ListItemIcon
                    sx={{
                        minWidth: 0,
                        mr: 1,
                    }}
                >
                    {renderIcon(item.icon)}
                </ListItemIcon>
            )}
            <ListItemText
                primary={
                    <div
                        style={{
                            fontSize: '14px',
                            fontWeight: 600,
                            ...textSx,
                        }}
                    >
                        {item.title}
                    </div>
                }
            />
            {item.badge && <NavChip chip={item.badge} />}
            <Tooltip title={`${isBookmark ? 'Remove from' : 'Add to'} Bookmarks`}>
                <IconButton
                    size="small"
                    edge="end"
                    onClick={(e) => {
                        e.preventDefault();
                        onBookmarkClick();
                    }}
                    sx={(theme) => ({
                        opacity: 0,
                        '.MuiListItemButton-root:hover &': {
                            opacity: 1,
                        },
                        color: isBookmark ? theme.palette.error.main : 'currentColor',
                        '& svg path': {
                            fill: isBookmark ? theme.palette.error.main : 'transparent',
                            stroke: isBookmark ? theme.palette.error.main : 'currentColor',
                        },
                    })}
                >
                    {renderIcon('Bookmarks')}
                </IconButton>
            </Tooltip>
        </ListItemButton>
    );
};

export default NavItemRenderer;
